import Fade from 'react-bootstrap/Fade'

const pendingTransitions = new WeakMap<HTMLElement, () => void>()

function parseTime(value: string): number {
  const time = parseFloat(value)
  return Number.isFinite(time) ? time * (value.trim().endsWith('ms') ? 1 : 1000) : 0
}

function transitionDuration(element: HTMLElement): number {
  const style = (element.ownerDocument.defaultView || window).getComputedStyle(element)
  const durations = style.transitionDuration.split(',').map(parseTime)
  const delays = style.transitionDelay.split(',').map(parseTime)

  return Math.max(
    0,
    ...durations.map((duration, index) => duration + delays[index % delays.length])
  )
}

export function transitionEndListener(element: HTMLElement, done: () => void): () => void {
  // A rapid close/reopen cancels the previous React transition on this element.
  pendingTransitions.get(element)?.()

  function cleanup() {
    window.clearTimeout(timeout)
    element.removeEventListener('transitionend', handleEnd)
    pendingTransitions.delete(element)
  }

  function finish() {
    cleanup()
    done()
  }

  function handleEnd(event: Event) {
    // Descendant transitions must not complete this transition or disable its fallback.
    if (event.target === element) finish()
  }

  const timeout = window.setTimeout(finish, transitionDuration(element) + 5)
  element.addEventListener('transitionend', handleEnd)
  pendingTransitions.set(element, cleanup)
  return cleanup
}

export function configureBootstrapTransitions(): void {
  // React Bootstrap 2.5.0-beta.1 disables Fade's timeout for modal transitions.
  // Its dom-helpers fallback can be cancelled by a child's transitionend, leaving
  // the transparent modal/backdrop and the scroll/focus lock mounted indefinitely.
  // Keep the animations and let React Bootstrap perform its normal onExited cleanup.
  const defaults = {...Fade.defaultProps, addEndListener: transitionEndListener}
  Fade.defaultProps = defaults
}
